import { render, staticRenderFns } from "./file-service-grid.vue?vue&type=template&id=24ed7663&scoped=true&"
import script from "./file-service-grid.vue?vue&type=script&lang=ts&"
export * from "./file-service-grid.vue?vue&type=script&lang=ts&"
import style0 from "./file-service-grid.vue?vue&type=style&index=0&id=24ed7663&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24ed7663",
  null
  
)

export default component.exports